import React from "react";
import { Link, useParams } from "react-router-dom";
import DecryptData from "../utils/Decrypt";

function StandardNavLinks() {
  const { stdId } = useParams();
  const userPermission = localStorage.getItem("nOiSsImRePrEsU")
    ? DecryptData("nOiSsImRePrEsU")
    : [];

  let InformationView = userPermission
    ? userPermission.some(
        (permission) => permission.permissionName == "information_view"
      )
    : false;
  let ActivityView = userPermission
    ? userPermission.some(
        (permission) => permission.permissionName == "activity_view"
      )
    : false;
  let GlossaryView = userPermission
    ? userPermission.some(
        (permission) => permission.permissionName == "glossary_view"
      )
    : false;
  let ReportView = userPermission
    ? userPermission.some(
        (permission) => permission.permissionName == "reports_view"
      )
    : false;

  let links = [
    {
      name: "Information",
      access: InformationView,
      submenu: true,
      sublinks: [
        {
          name: "Standard Information",
          link: "/information/standard-information",
        },
        {
          name: "Calendar Management",
          link: "/information/calendar-management",
        },
        {
          name: "Task Management",
          link: "/information/task-management",
        },
        { name: "Vendor Management", link: "/information/vendor-management" },
        { name: "Service Levels", link: "/information/service-levels" },
        { name: "Security Incident", link: "/information/security-incident" },
        { name: "Training Calendar", link: "/information/training-calendar" },
      ],
    },
    {
      name: "Activity",
      access: ActivityView,
      submenu: true,
      sublinks: [
        {
          name: "Implementation Checklist",
          link: `/activity/implementation-checklist`,
        },
        {
          name: "Master List of Documents",
          link: "/activity/master-list-of-documents",
        },
        { name: "Audit Schedule", link: "/activity/audit-schedule" },
        { name: "Internal Audit Checklist", link: "/activity/internal-audit-checklist" },
        { name: "CISO / MRM Meeting MoM", link: "/activity/ciso-mom" },
        { name: "Maintenance", link: "/activity/maintenance" },
      ],
    },

    {
      name: "Reference Docs",
      access: GlossaryView,
      submenu: true,
      sublinks: [
        {
          name: "Reference Doc Format",
          link: "/reference-doc/reference-doc-format",
        },
        {
          name: "Website Tracking",
          link: `/reference-doc/website-tracking`,
        },
        {
          name: "Consent Management",
          link: "/reference-doc/consent-management",
        },
        {
          name: "Certification Tracking",
          link: "/reference-doc/certification-tracking",
        },
        {
          name: "Statutory Reporting",
          link: "/reference-doc/statutory-reporting",
        },
        {
          name: "Cookie Management",
          link: "/reference-doc/cookie-management",
        },
        {
          name: "Glossary / FAQ",
          link: "/reference-doc/glossary-faq",
        },
        { name: "I E Audit Reports", link: "/reference-doc/ie-audit-reports" },
        {
          name: "Standard Comparison",
          link: "/reference-doc/standard-comparison",
        },
        { name: "Diagrams / Logo's", link: "/reference-doc/diagramsandlogos" },
      ],
    },
    {
      name: "Reports",
      access: ReportView,
      submenu: true,
      sublinks: [
        { name: "Reports List", link: "/report/genarate-report" },
      ],
    },
  ];
  return (
    <>
      {links.map((link, idx) => (
        <div key={idx}>
          {link.access && (
            <div className="group inline-block">
              {link.submenu == false && link.link ? (
                <Link to={`/standard/${stdId}${link.link}`}>
                  <button className="outline-none flex justify-center items-center focus:outline-none mx-4">
                    <span className="py-3 flex justify-between items-center md:pr-0 pr-5 group text-white font-medium text-xs 2xl:text-sm">
                      {link.name}
                    </span>
                  </button>
                </Link>
              ) : (
                <button className="outline-none flex justify-center items-center focus:outline-none mx-4">
                  <span className="py-3 flex justify-between items-center md:pr-0 pr-5 group text-white font-medium text-xs 2xl:text-sm">
                    {link.name}
                  </span>
                  <span>
                    <svg
                      className=" h-4 w-4 transform group-hover:-rotate-180
                               transition duration-150 ease-in-out"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="#fff"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                        stroke="#fff"
                      />
                    </svg>
                  </span>
                </button>
              )}

              {link.submenu && (
                <ul
                  className="bg-white rounded-xl shadow-[rgba(50,_50,_105,_0.15)_0px_2px_5px_0px,_rgba(0,_0,_0,_0.05)_0px_1px_1px_0px] transform scale-0 group-hover:scale-100 absolute -mt-3
              transition duration-150 ease-in-out origin-top min-w-32 py-2 px-1 z-20"
                >
                  {link.sublinks.map((mysublinks, idx) => (
                    <>
                      {mysublinks.submenu ? (
                        <>
                          <li className="p-2 hover:bg-navhover rounded-md relative">
                            <button className="w-full text-left flex items-center outline-none focus:outline-none">
                              <span className="pr-1 flex-1 text-xs 2xl:text-sm">
                                {mysublinks.name}
                              </span>
                              <span className="mr-auto">
                                <svg
                                  className="fill-current h-4 w-4
                        transition duration-150 ease-in-out"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                </svg>
                              </span>
                            </button>
                            <ul
                              className="bg-white rounded-md absolute top-0 right-0 
              transition duration-150 ease-in-out origin-top-left
              min-w-32 z-30 py-2 px-1 shadow-[rgba(50,_50,_105,_0.15)_0px_2px_5px_0px,_rgba(0,_0,_0,_0.05)_0px_1px_1px_0px]"
                            >
                              {mysublinks.sublinks.map((sublink, idx) => (
                                <Link
                                  to={`/standard/${stdId}${sublink.link}`}
                                  className="text-xs 2xl:text-sm"
                                  key={idx}
                                >
                                  <li className="p-2 hover:bg-navhover rounded-md">
                                    {sublink.name}
                                  </li>
                                </Link>
                              ))}
                            </ul>
                          </li>
                        </>
                      ) : (
                        <Link
                          to={`/standard/${stdId}${mysublinks.link}`}
                          className="text-xs 2xl:text-sm"
                          key={idx}
                        >
                          <li className="p-2 hover:bg-navhover rounded-md">
                            {mysublinks.name}
                          </li>
                        </Link>
                      )}
                    </>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
      ))}
    </>
  );
}

export default StandardNavLinks;
